<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 shape-primary shape-skew">
            </div>
            <div class="container shape-container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-7">
                        <h2 class="text-white display-1 pb-2 d-none d-sm-block">Acervo de Seriados</h2>
                        <p class="lead pb-2 text-white d-none d-sm-block" v-if="categoryName">
                          Gênero: {{categoryName.nome}}
                        </p>
                        <movie-search-form></movie-search-form>
                    </div>
                </div>
            </div>
        </section>
        
        <movie-card-deck classes="mt--400 pt-4" pagination filters seriados></movie-card-deck>

        <call-to-action outside invert gradient="primary" title="Minhas Autorações" text="São os filmes onde a sincronia da dublagem e a inserção no DVD original foram feitas por mim. Que tal conferir meu acervo de autoração própria?" button-title="Acessar Títulos" button-route="/filmes?origem=301"></call-to-action>
    </div>
</template>
<script>
import MovieSearchForm from '@/layout/components/Catalog/MovieSearchForm';
import MovieCardDeck from "@/layout/components/Catalog/MovieCardDeck";
import CallToAction from "@/layout/components/Catalog/CallToAction";

export default {
    components: {
        MovieSearchForm,
        MovieCardDeck,
        CallToAction
    },
    computed: {
      categoryName() {
        var selfCat = this.$route.params.genero;
        return this.$store.state.catalog.generos.find(function(item) {
            return item.slug == selfCat;
        });
      }
    }
};
</script>
<style>
</style>
